// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"attendancemarked_maindiv__2YdvA"};